exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".article-header[data-v-307c4426]{display:flex;flex-direction:row;justify-content:space-between;align-items:center;padding:.5rem 0}.article-header p[data-v-307c4426]{font-size:1rem;padding-left:1.25rem}.article-header p span[data-v-307c4426]{--text-opacity:1;color:#d29a00;color:rgba(210,154,0,var(--text-opacity));font-size:1rem}", ""]);

// exports
